import React, { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import SiteHeader from "../components/SiteHeader";
import SiteFooter from "../components/SiteFooter";

const copyByLang = {
  es: {
    title: "Eventos | Puerto Rico Esports League",
    description: "Explora los eventos pasados de Puerto Rico Esports League y la historia competitiva de la liga en Puerto Rico.",
    ogDescription: "Timeline visual de flyers, torneos y archivo histórico de PREL.",
    heroEyebrow: "Puerto Rico Esports League — Archivo histórico",
    heroTitle1: "Eventos",
    heroTitle2: "pasados",
    heroTitle3: "de PREL",
    heroBody:
      "Un archivo curado de flyers, torneos y momentos visuales que enseñan cómo PREL siguió construyendo comunidad, presencia y cultura competitiva dentro y fuera de los eventos presenciales.",
    totalYears: "Bloques curatoriales",
    totalPosters: "Artes destacados",
    totalPhotos: "Fotos de archivo",
    artLine: "Línea de artes",
    artDesc: "Selección curada de posters y flyers representativos.",
    photoLine: "Línea de fotos",
    photoDesc: "Momentos de archivo para acompañar la historia visual de la liga.",
    chapterEyebrow: "¿Listo para el próximo capítulo?",
    chapterTitle1: "El siguiente evento",
    chapterTitle2: "eres tú.",
    chapterCta: "Ver próximos eventos →",
    close: "✕ Cerrar",
    modalBody:
      "Archivo visual de Puerto Rico Esports League. Esta pieza forma parte de la presentación histórica de eventos, torneos, activaciones y momentos de comunidad construidos por PREL a lo largo de distintas etapas.",
    artLabel: "Arte / Flyer",
    photoLabel: "Foto de archivo",
    blocks: [
      {
        year: "2026",
        title: "Expansión y presencia en vivo",
        blurb: "Una etapa donde PREL ya opera con más visibilidad pública, integrando activaciones, eventos ancla y presencia cultural dentro del ecosistema local. Del Norte 2026 forma parte de esa presencia reciente con programación abierta al público y activaciones dentro de Norte Comic.",
        posters: [
          { title: "Del Norte 2026", image: "/past-events/del-norte-2026.png", fit: "contain", badge: "Reciente", href: "https://curzon.pr/nortecomic2026/" },
          { title: "PRCC 2026", image: "/prcc.png", href: "/prcc-2026", badge: "Destacado", fit: "contain" },
          { title: "PREL Showcase 2026", image: "/past-events/event-01.png", fit: "contain" },
          { title: "Archivo PREL 2026", image: "/past-events/event-02.png", fit: "contain" },
        ],
        photos: [
          { src: "/past-events/photos/IMG_2164.jpg", alt: "Evento presencial de PREL" },
          { src: "/past-events/photos/IMG_2239.jpg", alt: "Participación en evento de PREL" },
          { src: "/past-events/photos/IMG_2177.jpg", alt: "Ambiente competitivo de PREL" },
        ],
      },
      {
        year: "2025",
        title: "Circuito y consistencia",
        blurb: "PREL mantiene continuidad de marca y programación con un archivo visual que sigue creciendo entre torneos, activaciones y presencia digital.",
        posters: [
          { title: "Circuito PREL 2025", image: "/past-events/event-03.png", fit: "contain" },
          { title: "Archivo PREL 2025", image: "/past-events/event-04.png", fit: "contain" },
          { title: "Archivo PREL 2025 · Edición especial", image: "/past-events/event-05.png", fit: "contain" },
        ],
        photos: [
          { src: "/past-events/photos/IMG_2604.JPG", alt: "Cobertura de evento PREL", objectPosition: "center center" },
          { src: "/past-events/photos/IMG_1521.JPG", alt: "Comunidad en torneo PREL", objectPosition: "center 18%" },
          { src: "/past-events/photos/IMG_2918 (1).JPG", alt: "Escena de competencia PREL", objectPosition: "center 20%" },
        ],
      },
      {
        year: "2024",
        title: "Producción, activaciones y momentum",
        blurb: "La narrativa de PREL se vuelve más robusta, con materiales que reflejan ambición visual, continuidad operativa y mejor presencia editorial.",
        posters: [
          { title: "PREL Championship 2024", image: "/past-events/event-06.png", fit: "contain" },
          { title: "Archivo PREL 2024", image: "/past-events/event-07.png", fit: "contain" },
          { title: "Archivo PREL 2024 · Showcase", image: "/past-events/event-08.png", fit: "contain" },
        ],
        photos: [
          { src: "/past-events/photos/IMG_5075 (1).JPG", alt: "Escena de evento PREL" },
          { src: "/past-events/photos/IMG_6467 (1).jpg", alt: "Producción en evento PREL" },
          { src: "/past-events/photos/IMG_4376.jpg", alt: "Activación de PREL" },
        ],
      },
      {
        year: "2023",
        title: "Regreso visible y nueva etapa",
        blurb: "Desde 2023 en adelante, la operación retoma músculo presencial con un lenguaje más pulido, más limpio y con mejor presencia de marca.",
        posters: [
          { title: "PREL 2023 All Stars", image: "/past-events/event-10.png", fit: "contain" },
          { title: "Archivo PREL 2023", image: "/past-events/event-11.png", fit: "contain" },
          { title: "Archivo PREL 2023 · Multi-juego", image: "/past-events/event-12.png", fit: "contain" },
          { title: "Archivo PREL 2023 · Showcase", image: "/past-events/event-13.png", fit: "contain" },
        ],
        photos: [
          { src: "/past-events/photos/IMG_4375.jpg", alt: "Evento presencial PREL 2023" },
          { src: "/past-events/photos/a9ebeb32-e22f-4ac9-a2f4-16f90a5bc652.jpg", alt: "Foto de archivo PREL" },
          { src: "/past-events/photos/IMG_4989.JPG", alt: "Cobertura PREL en vivo" },
          { src: "/past-events/photos/IMG_1370.JPG", alt: "Escena de torneo PREL" },
        ],
      },
      {
        year: "2022–2020",
        title: "Pandemia, adaptación y continuidad",
        blurb: "La pandemia afectó el ritmo presencial, pero PREL siguió activo. En este periodo la plataforma sostuvo comunidad y competencia con streaming, torneos y formatos digitales que mantuvieron viva la operación.",
        posters: [
          { title: "Archivo PREL 2022", image: "/past-events/event-14.png", fit: "contain" },
          { title: "PREL 2021 Digital", image: "/past-events/event-18.png", fit: "contain" },
          { title: "PREL Histórico 2020", image: "/past-events/event-21.png", fit: "contain" },
        ],
        photos: [
          { src: "/past-events/photos/IMG_0750.JPG", alt: "Producción digital PREL" },
          { src: "/past-events/photos/IMG_0556.JPG", alt: "Momento de torneo PREL" },
          { src: "/past-events/photos/IMG_4862.JPG", alt: "Cobertura visual de PREL" },
          { src: "/past-events/photos/IMG_5074.JPG", alt: "Competencia histórica PREL" },
        ],
      },
    ],
  },
  en: {
    title: "Events | Puerto Rico Esports League",
    description: "Explore Puerto Rico Esports League's past events and the competitive history of the league in Puerto Rico.",
    ogDescription: "A visual timeline of flyers, tournaments, and PREL's historical archive.",
    heroEyebrow: "Puerto Rico Esports League — Historical archive",
    heroTitle1: "Past",
    heroTitle2: "events",
    heroTitle3: "from PREL",
    heroBody:
      "A curated archive of flyers, tournaments, and visual moments that show how PREL kept building community, presence, and competitive culture inside and beyond in-person events.",
    totalYears: "Curated blocks",
    totalPosters: "Featured art pieces",
    totalPhotos: "Archive photos",
    artLine: "Art line",
    artDesc: "A curated selection of representative posters and flyers.",
    photoLine: "Photo line",
    photoDesc: "Archive moments that help tell the league's visual story.",
    chapterEyebrow: "Ready for the next chapter?",
    chapterTitle1: "The next event",
    chapterTitle2: "is you.",
    chapterCta: "View upcoming events →",
    close: "✕ Close",
    modalBody:
      "Visual archive from Puerto Rico Esports League. This piece is part of PREL's historical presentation of events, tournaments, activations, and community moments built across different stages.",
    artLabel: "Art / Flyer",
    photoLabel: "Archive photo",
    blocks: [
      {
        year: "2026",
        title: "Expansion and live presence",
        blurb: "A stage where PREL is already operating with greater public visibility, integrating activations, anchor events, and cultural presence inside the local ecosystem. Del Norte 2026 is part of that recent presence, with public programming and activations inside Norte Comic.",
        posters: [
          { title: "Del Norte 2026", image: "/past-events/del-norte-2026.png", fit: "contain", badge: "Recent", href: "https://curzon.pr/nortecomic2026/" },
          { title: "PRCC 2026", image: "/prcc.png", href: "/prcc-2026", badge: "Featured", fit: "contain" },
          { title: "PREL Showcase 2026", image: "/past-events/event-01.png", fit: "contain" },
          { title: "PREL Archive 2026", image: "/past-events/event-02.png", fit: "contain" },
        ],
        photos: [
          { src: "/past-events/photos/IMG_2164.jpg", alt: "PREL in-person event" },
          { src: "/past-events/photos/IMG_2239.jpg", alt: "PREL event participation" },
          { src: "/past-events/photos/IMG_2177.jpg", alt: "PREL competitive atmosphere" },
        ],
      },
      {
        year: "2025",
        title: "Circuit and consistency",
        blurb: "PREL maintains brand continuity and programming with a visual archive that keeps growing across tournaments, activations, and digital presence.",
        posters: [
          { title: "PREL Circuit 2025", image: "/past-events/event-03.png", fit: "contain" },
          { title: "PREL Archive 2025", image: "/past-events/event-04.png", fit: "contain" },
          { title: "PREL Archive 2025 · Special Edition", image: "/past-events/event-05.png", fit: "contain" },
        ],
        photos: [
          { src: "/past-events/photos/IMG_2604.JPG", alt: "PREL event coverage", objectPosition: "center center" },
          { src: "/past-events/photos/IMG_1521.JPG", alt: "PREL tournament community", objectPosition: "center 18%" },
          { src: "/past-events/photos/IMG_2918 (1).JPG", alt: "PREL competition scene", objectPosition: "center 20%" },
        ],
      },
      {
        year: "2024",
        title: "Production, activations, and momentum",
        blurb: "PREL's narrative becomes more robust, with materials that reflect visual ambition, operational continuity, and a stronger editorial presence.",
        posters: [
          { title: "PREL Championship 2024", image: "/past-events/event-06.png", fit: "contain" },
          { title: "PREL Archive 2024", image: "/past-events/event-07.png", fit: "contain" },
          { title: "PREL Archive 2024 · Showcase", image: "/past-events/event-08.png", fit: "contain" },
        ],
        photos: [
          { src: "/past-events/photos/IMG_5075 (1).JPG", alt: "PREL event scene" },
          { src: "/past-events/photos/IMG_6467 (1).jpg", alt: "PREL event production" },
          { src: "/past-events/photos/IMG_4376.jpg", alt: "PREL activation" },
        ],
      },
      {
        year: "2023",
        title: "Visible return and new stage",
        blurb: "From 2023 onward, the operation regains in-person strength with a more polished visual language and stronger brand presence.",
        posters: [
          { title: "PREL 2023 All Stars", image: "/past-events/event-10.png", fit: "contain" },
          { title: "PREL Archive 2023", image: "/past-events/event-11.png", fit: "contain" },
          { title: "PREL Archive 2023 · Multi-title", image: "/past-events/event-12.png", fit: "contain" },
          { title: "PREL Archive 2023 · Showcase", image: "/past-events/event-13.png", fit: "contain" },
        ],
        photos: [
          { src: "/past-events/photos/IMG_4375.jpg", alt: "PREL in-person event 2023" },
          { src: "/past-events/photos/a9ebeb32-e22f-4ac9-a2f4-16f90a5bc652.jpg", alt: "PREL archive photo" },
          { src: "/past-events/photos/IMG_4989.JPG", alt: "PREL live coverage" },
          { src: "/past-events/photos/IMG_1370.JPG", alt: "PREL tournament scene" },
        ],
      },
      {
        year: "2022–2020",
        title: "Pandemic, adaptation, and continuity",
        blurb: "The pandemic affected the in-person rhythm, but PREL stayed active. During this period the platform sustained community and competition through streaming, tournaments, and digital formats that kept the operation alive.",
        posters: [
          { title: "PREL Archive 2022", image: "/past-events/event-14.png", fit: "contain" },
          { title: "PREL 2021 Digital", image: "/past-events/event-18.png", fit: "contain" },
          { title: "Historic PREL 2020", image: "/past-events/event-21.png", fit: "contain" },
        ],
        photos: [
          { src: "/past-events/photos/IMG_0750.JPG", alt: "PREL digital production" },
          { src: "/past-events/photos/IMG_0556.JPG", alt: "PREL tournament moment" },
          { src: "/past-events/photos/IMG_4862.JPG", alt: "PREL visual coverage" },
          { src: "/past-events/photos/IMG_5074.JPG", alt: "Historic PREL competition" },
        ],
      },
    ],
  },
};

function MediaCard({ item, type = "poster", onClick, copy }) {
  const isPoster = type === "poster";
  const sharedClassName = `group text-left relative overflow-hidden rounded-[24px] border transition-all duration-300 ${
    isPoster
      ? "border-white/10 bg-[linear-gradient(180deg,rgba(18,24,38,0.92),rgba(8,10,16,0.98))] hover:border-[#CE1126]/45"
      : "border-white/8 bg-[linear-gradient(180deg,rgba(255,255,255,0.04),rgba(255,255,255,0.02))] hover:border-white/20"
  }`;

  const content = (
    <>
      {item.badge ? (
        <span className="absolute left-4 top-4 z-20 rounded-full bg-[#F5C842] px-3 py-1 text-[10px] font-black uppercase tracking-[0.22em] text-black">
          {item.badge}
        </span>
      ) : null}

      <div className={`relative w-full ${isPoster ? "aspect-[4/5] p-4 md:p-5" : "aspect-[16/10]"}`}>
        <img
          src={item.image || item.src}
          alt={item.title || item.alt}
          className={`h-full w-full transition-transform duration-500 group-hover:scale-[1.025] ${
            isPoster ? (item.fit === "cover" ? "object-cover rounded-[18px]" : "object-contain") : "object-cover"
          }`}
          style={!isPoster && item.objectPosition ? { objectPosition: item.objectPosition } : undefined}
        />
        <div className={`absolute inset-0 ${isPoster ? "bg-gradient-to-t from-black/55 via-transparent to-transparent" : "bg-gradient-to-t from-black/60 via-black/10 to-transparent"}`} />
      </div>

      <div className={`${isPoster ? "px-5 pb-5" : "absolute inset-x-0 bottom-0 p-4"}`}>
        <p className={`uppercase tracking-[0.22em] ${isPoster ? "text-[10px] text-[#CE1126]" : "text-[10px] text-slate-300"}`}>
          {isPoster ? copy.artLabel : copy.photoLabel}
        </p>
        <h3 className={`mt-2 font-bold leading-tight ${isPoster ? "text-base md:text-lg text-white" : "text-sm md:text-base text-white"}`}>
          {item.title || item.alt}
        </h3>
      </div>
    </>
  );

  if (item.href) {
    return <a href={item.href} className={sharedClassName}>{content}</a>;
  }

  return <button type="button" onClick={() => onClick(item)} className={sharedClassName}>{content}</button>;
}

export default function EventsPage() {
  const { i18n } = useTranslation();
  const lang = i18n.language === "en" ? "en" : "es";
  const copy = copyByLang[lang];
  const [selected, setSelected] = useState(null);

  useEffect(() => {
    document.title = copy.title;

    const setMeta = (name, content, isProperty = false) => {
      const selector = isProperty ? `meta[property='${name}']` : `meta[name='${name}']`;
      let tag = document.head.querySelector(selector);
      if (!tag) {
        tag = document.createElement("meta");
        if (isProperty) tag.setAttribute("property", name);
        else tag.setAttribute("name", name);
        document.head.appendChild(tag);
      }
      tag.setAttribute("content", content);
    };

    setMeta("description", copy.description);
    setMeta("og:title", copy.title, true);
    setMeta("og:description", copy.ogDescription, true);
    setMeta("og:type", "website", true);
    setMeta("og:url", "https://www.puertoricoesportleague.com/eventos", true);
    setMeta("og:image", "https://www.puertoricoesportleague.com/logo.png", true);
    setMeta("twitter:card", "summary_large_image");

    let canonical = document.head.querySelector("link[rel='canonical']");
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.setAttribute("rel", "canonical");
      document.head.appendChild(canonical);
    }
    canonical.setAttribute("href", "https://www.puertoricoesportleague.com/eventos");
  }, [copy]);

  const totals = useMemo(() => {
    const totalPosters = copy.blocks.reduce((acc, block) => acc + block.posters.length, 0);
    const totalPhotos = copy.blocks.reduce((acc, block) => acc + block.photos.length, 0);
    return { totalYears: copy.blocks.length, totalPosters, totalPhotos };
  }, [copy.blocks]);

  return (
    <div className="min-h-screen bg-[#080A10] text-[#F0EEE8]">
      <SiteHeader current="/eventos" />

      <section className="relative min-h-[72vh] md:min-h-[88vh] flex items-center overflow-hidden px-5 md:px-10 pb-12 md:pb-20 pt-24 md:pt-0">
        <div className="absolute inset-0 bg-[radial-gradient(ellipse_70%_60%_at_80%_30%,rgba(0,42,143,0.22)_0%,transparent_65%),radial-gradient(ellipse_50%_70%_at_10%_90%,rgba(206,17,38,0.15)_0%,transparent_60%)]" />
        <div className="absolute inset-0 bg-[linear-gradient(rgba(255,255,255,0.02)_1px,transparent_1px),linear-gradient(90deg,rgba(255,255,255,0.02)_1px,transparent_1px)] bg-[size:72px_72px]" />

        <div className="relative z-10 w-full max-w-[1440px] mx-auto">
          <p className="text-[10px] md:text-xs uppercase tracking-[0.26em] md:tracking-[0.32em] text-[#CE1126]">{copy.heroEyebrow}</p>
          <h1 className="mt-4 font-black leading-[0.9] uppercase text-[clamp(2.35rem,11vw,8rem)]">
            {copy.heroTitle1} <span className="text-[#CE1126]">{copy.heroTitle2}</span><br />
            <span className="text-transparent [-webkit-text-stroke:1px_rgba(240,238,232,0.24)]">{copy.heroTitle3}</span>
          </h1>
          <p className="mt-5 md:mt-6 max-w-2xl text-sm md:text-base text-slate-300 leading-relaxed">{copy.heroBody}</p>

          <div className="mt-8 md:mt-10 grid grid-cols-2 sm:flex sm:flex-wrap gap-5 md:gap-8 max-w-2xl">
            <div>
              <p className="text-3xl md:text-4xl font-black">{totals.totalYears}</p>
              <p className="text-xs uppercase tracking-[0.2em] text-slate-400">{copy.totalYears}</p>
            </div>
            <div>
              <p className="text-3xl md:text-4xl font-black">{totals.totalPosters}+</p>
              <p className="text-xs uppercase tracking-[0.2em] text-slate-400">{copy.totalPosters}</p>
            </div>
            <div>
              <p className="text-3xl md:text-4xl font-black">{totals.totalPhotos}+</p>
              <p className="text-xs uppercase tracking-[0.2em] text-slate-400">{copy.totalPhotos}</p>
            </div>
          </div>
        </div>
      </section>

      <section className="pb-24">
        <div className="mx-auto flex max-w-[1440px] flex-col gap-8 px-5 md:px-10">
          {copy.blocks.map((block, index) => (
            <section key={block.year} className={`rounded-[34px] border border-white/10 bg-[linear-gradient(180deg,rgba(15,18,32,0.96),rgba(8,10,16,0.98))] p-5 md:p-8 xl:p-10 shadow-[0_30px_120px_rgba(0,0,0,0.28)] ${index === copy.blocks.length - 1 ? "-mt-2 md:-mt-4" : ""}`}>
              <div className="grid gap-8 xl:grid-cols-[320px_minmax(0,1fr)] xl:gap-10">
                <div>
                  <p className="text-xs uppercase tracking-[0.32em] text-[#CE1126]">{block.year}</p>
                  <h2 className="mt-3 text-3xl md:text-5xl font-black uppercase leading-[0.95]">{block.title}</h2>
                  <p className="mt-5 text-sm md:text-base leading-relaxed text-slate-300">{block.blurb}</p>
                </div>

                <div className="space-y-7">
                  <div>
                    <div className="mb-4 flex items-center justify-between gap-4">
                      <div>
                        <p className="text-[10px] uppercase tracking-[0.3em] text-[#F5C842]">{copy.artLine}</p>
                        <p className="mt-1 text-sm text-slate-400">{copy.artDesc}</p>
                      </div>
                    </div>
                    <div className="grid gap-4 sm:grid-cols-2 xl:grid-cols-4">
                      {block.posters.map((item) => <MediaCard key={`${block.year}-${item.image}`} item={item} type="poster" onClick={setSelected} copy={copy} />)}
                    </div>
                  </div>

                  <div>
                    <div className="mb-4 flex items-center justify-between gap-4">
                      <div>
                        <p className="text-[10px] uppercase tracking-[0.3em] text-cyan-300">{copy.photoLine}</p>
                        <p className="mt-1 text-sm text-slate-400">{copy.photoDesc}</p>
                      </div>
                    </div>
                    <div className="grid gap-4 sm:grid-cols-2 xl:grid-cols-4">
                      {block.photos.map((item) => <MediaCard key={`${block.year}-${item.src}`} item={item} type="photo" onClick={setSelected} copy={copy} />)}
                    </div>
                  </div>
                </div>
              </div>
            </section>
          ))}
        </div>
      </section>

      <section className="px-5 md:px-10 py-12 md:py-16 bg-[#0F1220] border-y border-white/10 flex flex-col md:flex-row md:items-center md:justify-between gap-6">
        <div>
          <p className="text-xs uppercase tracking-[0.3em] text-[#CE1126]">{copy.chapterEyebrow}</p>
          <h3 className="mt-3 text-3xl md:text-6xl font-black leading-[0.95] uppercase">{copy.chapterTitle1}<br /><span className="text-[#CE1126]">{copy.chapterTitle2}</span></h3>
        </div>
        <a href="/#eventos" className="inline-flex items-center gap-3 px-6 py-4 bg-[#CE1126] hover:bg-[#a50e1e] transition uppercase tracking-[0.2em] text-xs font-bold">
          {copy.chapterCta}
        </a>
      </section>

      {selected ? (
        <div className="fixed inset-0 z-[120] bg-black/90 backdrop-blur-sm p-4 md:p-10 flex items-center justify-center" onClick={() => setSelected(null)}>
          <div className="relative w-full max-w-5xl overflow-hidden rounded-[28px] border border-white/10 bg-[#141828]" onClick={(e) => e.stopPropagation()}>
            <button className="absolute top-4 right-4 z-20 text-xs uppercase tracking-[0.2em] text-slate-300 hover:text-white" onClick={() => setSelected(null)}>
              {copy.close}
            </button>
            <div className="grid md:grid-cols-[minmax(0,1.2fr)_minmax(320px,0.8fr)]">
              <div className="bg-black/30 p-4 md:p-6 flex items-center justify-center min-h-[320px] md:min-h-[640px]">
                <img src={selected.image || selected.src} alt={selected.title || selected.alt} className="max-h-[78vh] w-full object-contain" />
              </div>
              <div className="p-6 md:p-8">
                <p className="text-xs uppercase tracking-[0.24em] text-[#CE1126]">{selected.badge ? selected.badge : selected.fit ? copy.artLabel : copy.photoLabel}</p>
                <h4 className="mt-3 text-3xl font-black leading-tight uppercase">{selected.title || selected.alt}</h4>
                <p className="mt-6 text-sm leading-relaxed text-slate-300">{copy.modalBody}</p>
              </div>
            </div>
          </div>
        </div>
      ) : null}

      <SiteFooter />
    </div>
  );
}
